import { useReducer, useCallback } from 'react'
import { WishlistState, Action, WishlistManager } from './WishlistActionTypes'

export enum ActionType {
    ADD_SELECTED = 'ADD_SELECTED',
    REMOVE_SELECTED = 'REMOVE_SELECTED',
    RESET_SELECTED = 'RESET_SELECTED'
}

const initialState = {
    selected: []
}

const reducer = (state: WishlistState, action: Action): WishlistState => {
    switch (action.type) {
        case ActionType.ADD_SELECTED:
            return {
                ...state,
                ...{
                    selected: [...state.selected, ...[...action.payload]]
                }
            }
        case ActionType.REMOVE_SELECTED:
            return {
                ...state,
                ...{
                    selected: state.selected?.filter(
                        (item) => item !== action.payload
                    )
                }
            }
        case ActionType.RESET_SELECTED:
            return { ...state, ...{ selected: [] } }
        default:
            return state
    }
}

export const useWishlistManager = (): WishlistManager => {
    const [wishlistState, dispatch] = useReducer(reducer, initialState)

    const addSelected = useCallback(
        (payload) => {
            dispatch({ type: ActionType.ADD_SELECTED, payload })
        },
        [dispatch]
    )

    const removeSelected = useCallback(
        (payload) => {
            dispatch({ type: ActionType.REMOVE_SELECTED, payload })
        },
        [dispatch]
    )

    const resetSelected = useCallback(() => {
        dispatch({ type: ActionType.RESET_SELECTED })
    }, [dispatch])

    return {
        wishlistState,
        addSelected,
        removeSelected,
        resetSelected
    }
}
